var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGreenChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67526 9.68944C9.67526 10.3874 9.10955 10.9531 8.41161 10.9531C7.71367 10.9531 7.14795 10.3874 7.14795 9.68944C7.14795 8.9915 7.71367 8.42578 8.41161 8.42578C9.10955 8.42578 9.67526 8.9915 9.67526 9.68944Z",
    fill: "#006B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0458 0C9.42099 0 5.77626 2.22321 4.01785 5.44275C3.83793 5.55837 3.63606 5.69498 3.4134 5.85201C1.31538 7.59801 0 10.0578 0 12.7914C0 15.8584 1.65138 18.5804 4.21284 20.3359V23.805C4.21284 24.5273 4.64863 24.8458 5.31296 24.4369L8.93567 22.2065C9.59028 22.3135 10.2637 22.3755 10.9537 22.3757C13.7096 22.3757 15.6123 21.4797 17.3524 20.0089L18.9984 20.9621C19.9003 21.4843 20.6295 21.2897 20.6295 20.1617V17.1283C22.8311 15.2535 24 12.6507 24 9.58431C23.9996 4.29103 19.1035 0 13.0458 0ZM10.9535 20.9016C10.201 20.9016 9.47403 20.8153 8.77341 20.6699L5.89788 22.5865V19.6007C3.36368 18.1725 1.68523 15.7061 1.68562 12.8968C1.68562 11.4179 2.15575 10.0359 2.96799 8.84818C2.94643 9.09107 2.93517 9.33662 2.93517 9.58426C2.93517 14.8775 6.99635 19.3791 13.046 19.3791C13.7361 19.3791 15.2249 19.2634 15.8798 19.1562C14.2953 20.2457 13.1363 20.9016 10.9535 20.9016ZM18.944 16.393V19.3797L16.0684 17.4627C15.3684 17.6085 13.7985 17.6944 13.0462 17.6944C7.92776 17.6944 4.6205 14.1108 4.6205 9.68974C4.6205 5.2697 8.85605 1.6851 13.0462 1.68559C18.3097 1.68559 22.3144 5.26955 22.3144 9.68974C22.3144 12.4991 20.9988 14.7254 18.944 16.393Z",
    fill: "#006B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7866 9.68944C19.7866 10.3874 19.2209 10.9531 18.5229 10.9531C17.825 10.9531 17.2593 10.3874 17.2593 9.68944C17.2593 8.9915 17.825 8.42578 18.5229 8.42578C19.2209 8.42578 19.7866 8.9915 19.7866 9.68944Z",
    fill: "#006B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7315 9.68983C14.7315 10.388 14.1656 10.9539 13.4675 10.9539C12.7695 10.9539 12.2036 10.388 12.2036 9.68983C12.2036 8.99169 12.7695 8.42578 13.4675 8.42578C14.1656 8.42578 14.7315 8.99169 14.7315 9.68983Z",
    fill: "#006B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGreenChat);
export default __webpack_public_path__ + "static/media/ic_green-chat.5e1ae3246ce8b33c224bab3dda558fb3.svg";
export { ForwardRef as ReactComponent };